export default class PostMessageParser {
    authorizationCodeKey = 'authorizationCode';

    /**
     * @param {string} data - string query param data
     * @returns {string} - refined response data, query params mapped to object
     */
    getRefinedEventData = (data) => {
        const isResponseString = typeof data === 'string';
        const authorizationCodeKey = 'authorizationCode';
        const providersResponse =
            isResponseString && data.includes(authorizationCodeKey) ? data : '';

        return this.removeStartingQuestionMark(providersResponse);
    };

    /**
     * @param {string} data - string query param data
     * @returns {string} - data without starting questions mark
     */
    removeStartingQuestionMark = (data) => {
        return data[0] === '?' ? data.substring(1, data.length) : data;
    };

    /**
     * @param {string} data - query params data string
     * @returns {{key: string, value: string}} - query params map
     */
    getQueryParamsData = (data) => {
        const splitItem = data.split('=');

        return {
            key: splitItem[0],
            value: splitItem[1],
        };
    };

    /**
     * @param {string} postMessageData - post message string data
     * @returns {string} authenticationUrl - authentication code given by provider
     * required to link device with provider ID
     */
    parse = (postMessageData) => {
        const refinedEventData = this.getRefinedEventData(postMessageData);
        const authorizationCodeData =
            refinedEventData &&
            refinedEventData
                .split('&')
                .map((item) => this.getQueryParamsData(item))
                .filter((item) => item.key === this.authorizationCodeKey)
                .map((item) => item.value);

        return authorizationCodeData.length ? authorizationCodeData.reduce((item) => item) : '';
    };
}
